interface ReaderProfile {
  displayName: string;
  role: string;
}

const root = document.querySelector<HTMLDivElement>('#public-account-nav');

function addLink(container: HTMLElement, text: string, href: string): void {
  const link = document.createElement('a');
  link.href = href;
  link.textContent = text;
  container.append(link);
}

async function loadAccountNavigation(): Promise<void> {
  if (!root) return;
  try {
    const response = await fetch('/api/v1/auth/me', { credentials: 'same-origin' });
    if (response.status === 401) {
      addLink(root, 'Login', '/account/login');
      addLink(root, 'Register', '/account/register');
      return;
    }
    if (!response.ok) return;
    const profile = (await response.json()) as ReaderProfile;
    const menu = document.createElement('details');
    menu.className = 'public-account-menu';
    const summary = document.createElement('summary');
    const avatar = document.createElement('span');
    avatar.className = 'public-account-avatar';
    avatar.setAttribute('aria-hidden', 'true');
    avatar.textContent = profile.displayName.trim().charAt(0).toUpperCase() || 'A';
    const label = document.createElement('span');
    label.textContent = profile.displayName;
    summary.append(avatar, label);
    const logout = document.createElement('button');
    logout.type = 'button';
    logout.textContent = 'Log out';
    logout.addEventListener('click', async () => {
      try {
        const csrfResponse = await fetch('/api/v1/auth/csrf', { credentials: 'same-origin' });
        if (!csrfResponse.ok) return;
        const csrf = (await csrfResponse.json()) as { requestToken: string };
        const result = await fetch('/api/v1/auth/logout', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'X-CSRF-TOKEN': csrf.requestToken },
        });
        if (result.ok) window.location.reload();
      } catch {
        // Header controls fail silently when the account API is unavailable.
      }
    });
    menu.append(summary, logout);
    root.append(menu);
  } catch {
    // Do not change the public header when the account API is unavailable.
  }
}

void loadAccountNavigation();
